/**
 * Client-side password hashing utility
 * Uses SHA-256 to hash passwords before transmission
 * Ensures plaintext passwords never leave the device
 */

/**
 * Hash a password using SHA-256
 * @param {string} password - The plaintext password
 * @returns {Promise<string>} - 64-character lowercase hex string
 */
export async function hashPassword(password) {
  // Convert password string to Uint8Array
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  
  // Hash using SubtleCrypto (Web Crypto API)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  
  // Convert ArrayBuffer to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  
  return hashHex;
}

/**
 * Validate that a string is a valid SHA-256 hash
 * @param {string} hash - The hash to validate
 * @returns {boolean}
 */
export function isValidSHA256Hash(hash) {
  return typeof hash === 'string' && /^[a-f0-9]{64}$/.test(hash);
}
